export const extparDropdowns = [
    {
        fieldName: "ilu_type",
        options: [
            { value: 1, label: "Globcover2009" },
            { value: 2, label: "GLC2000" },
            { value: 6, label: "Ecoclimap-SG" },
        ],
        tooltip: "choose a land use raw data set",
        docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#namelist_input_for_extpar_lu",
    },
    {
        fieldName: "ialb_type",
        options: [
            { value: 1, label: "total albedo" },
            { value: 2, label: "soil albedo" },
            { value: 3, label: "total albedo without NI and UV fields" },
        ],
        tooltip: "choose an albedo type",
        docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#dict-input_alb-namelistpy",
    },
    {
        fieldName: "isoil_type",
        options: [
            { value: 1, label: "FAO" },
            { value: 2, label: "HWSD" },
            { value: 3, label: "HWSD with terra mapping" },
        ],
        tooltip: "choose a raw soil data type",
        docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#soil-data",
    },
    {
        fieldName: "itopo_type",
        options: [
            { value: 1, label: "GLOBE" },
            { value: 2, label: "ASTER" },
            { value: 3, label: "MERIT" },
        ],
        tooltip: "choose an orography raw data set",
        docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#namelist-orography_raw_data-input_oro",
    },
    {
        fieldName: "it_cl_type",
        options: [
            { value: 1, label: "new and fine" },
            { value: 2, label: "old and coarse over sea and the fine over land" },
        ],
        tooltip: "choose a raw data set",
        docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#dict-input_tclim-namelistpy",
    },
    {
        fieldName: "iera_type",
        options: [
            { value: 1, label: "ERA5" },
            { value: 2, label: "ERA-I" },
        ],
        tooltip: "choose an ERA climatology type",
        docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#dict-input_era-namelistpy",
    },
    {
        fieldName: "iemiss_type",
        options: [
            { value: 1, label: "full-range (3.6 & 14.3 micron)" },
            { value: 2, label: "long-wave (8.0 & 13.5 micron)" },
        ],
        tooltip: "choose an emissivity data type",
        docsLink: "https://c2sm.github.io/extpar/user_manual/user_manual_06_namelist_input/#dict-input_emiss-namelistpy",
    },
];

export const ilookupOptions = {
    1: [
        { value: 1, label: "operational settings (Asensio, 2011)" },
        { value: 2, label: "experimental settings, analogous to lookup tables of ECOCLIMAP (Asensio 2010)" },
    ],
    2: [
        { value: 1, label: "operational settings of GME (Ritter, 2007)" },
        { value: 2, label: "operational settings of COSMO (Heise, 2005)" },
        { value: 3, label: "experimental setting, analogous to lookup tables of ECOCLIMAP (Asensio 2010)" },
    ],
    6: [
        { value: 1, label: "Globcover analogue with added LCZs from Oke" },
    ],
}
